import React from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';

export function ReferencePage() {
  return (
    <>
      <SEO
        title="Reference | KELFAE LOFTER ApS"
        description="Se vores projekter og referencer. Vi tilbyder altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker og kompetent rådgivning."
      />

      <section className="bg-neutral-100 border-b border-neutral-200 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-900 bg-[#7FDCA7]/30 px-3 py-1 rounded-full border border-[#7FDCA7]/50 inline-block">
              Projekter & Referencer
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-neutral-900 font-serif-heading tracking-tight">
              Reference
            </h1>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8 text-xs sm:text-sm text-neutral-700 leading-relaxed">
          <div className="bg-neutral-50 border border-neutral-200 p-8 rounded-2xl space-y-6 shadow-sm">
            <h2 className="text-xl font-bold text-neutral-900 font-serif-heading border-b border-neutral-200 pb-3">
              Skræddersyede løsninger
            </h2>
            <p>
              Vores kunder har alle forskellige behov, og derfor tilbyder vi altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker. Inden vi går i gang, forventningsafstemmer vi med dig, så vi kan levere et resultat, der lever op til dine forventninger. Se vores projekter og referencer her.
            </p>

            <h3 className="text-lg font-bold text-neutral-900 font-serif-heading pt-2 border-t border-neutral-200">
              Kompetent rådgivning
            </h3>
            <p>
              Er du i tvivl om, hvilken løsning der er den bedste for dig? Det skal du ikke bekymre dig om. Vi tilbyder kompetent rådgivning i forbindelse med ethvert projekt og holder dig opdateret fra start til slut. Du er i trygge hænder hos os.
            </p>

            <div className="pt-4 flex flex-wrap gap-4">
              <Link
                to="/galleri"
                className="px-6 py-3 bg-[#7FDCA7] hover:bg-[#69C892] text-neutral-950 font-bold text-xs rounded-xl transition-all shadow-sm"
              >
                Se vores galleri
              </Link>
              <Link
                to="/kontakt"
                className="px-6 py-3 bg-white border border-neutral-300 text-neutral-900 font-semibold text-xs rounded-xl hover:bg-neutral-100 transition-all"
              >
                Kontakt os for tilbud
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
